<div class="row no-gutters mx-0 mb-3 mb-md-4 mb-lg-5 mt-2 mt-md-3 mt-lg-5">
  <div class="col-12 d-flex jc-sb">
    <img src="assets/images/bch.svg" class="img-fluid img-fluid-bch">
    <img src="assets/images/bec.svg" class="img-fluid img-fluid-bec" />
  </div>
</div>